import React from 'react'

function EmailInput({
  placeholder,
  value,
  onChange,
  onKeyPress,
  label,
  inputClass,
  labelClass,
  id
}) {
  return (
    <>
        <label id={id} className={`font-semibold text-secondary my-auto ${labelClass}`}>{label ? label : 'Email'}</label>
        <input aria-label="enter email adress" type="email" value={value} onChange={onChange} onKeyPress={onKeyPress} placeholder={placeholder} className={`bg-light focus:outline-none rounded text-sm leading-none text-secondary py-3 w-full pl-3 mt-2 ${inputClass}`}/>
    </>
  )
}

export default EmailInput
